// ExplorePage.js

import React, { useState, useEffect } from 'react';
import { Link, Navigate } from 'react-router-dom'; // Use Navigate instead of Redirect
import './ExplorePage.css';
import { getAllDataFromDB } from '../utils/dbUtilities';
import { useAuth } from '../contexts/AuthContext';

const ExploreItem = React.memo(({ post }) => (
    <div className="explore-item">
        <Link to={`/posts/${post.id}`}>
            <img 
                src={post.imageUrl} 
                alt="explore thumbnail"
                className="explore-thumbnail"
            />
        </Link>
    </div>
));

const ExplorePage = () => {
    const [posts, setPosts] = useState([]);
    const { currentUser } = useAuth();

    useEffect(() => {
        window.scrollTo(0, 0);

        async function fetchPosts() {
            try {
                let storedPosts = await getAllDataFromDB('posts');
                storedPosts = storedPosts
                    .map(post => ({
                        ...post,
                        timestamp: post.timestamp?.toDate ? post.timestamp.toDate() : new Date(post.timestamp)
                    }))
                    .sort((a, b) => b.timestamp - a.timestamp)
                    .filter(post => post.imageUrl);

                setPosts(storedPosts);
            } catch (error) {
                console.error("Error fetching posts:", error);
            }
        }
        fetchPosts();
    }, []);

    if (!currentUser) {
        return <Navigate to="/login" replace />; // Use Navigate for redirection
    }

    return (
        <div className="explore-container">
            <div className="explore-grid">
                {posts.map((post) => (
                    <ExploreItem key={post.id} post={post} />
                ))}
            </div>
        </div>
    );
};

export default ExplorePage;

